import TurmericImg from "../asset/gallary-stories/Turmeric.webp";
import morningYogaImg from "../asset/gallary-stories/morningyoga.jpg";
import massageTherapyImg from "../asset/gallary-stories/massagetherapy.png";
import SattvicFoodImg from "../asset/gallary-stories/SattvicFood.jpg";
import DailyRitualImg from "../asset/blogs/Daily Rituals.png";
import panchakaramaImg from "../asset/blogs/panchakarama.png";
import yogaclassImg from "../asset/blogs/yogaclass.jpg";
import wellnessImg from "../asset/testimonals/wellness.jpg";

export const blogData = [
  // --- Homepage Article List (IDs 1-5) ---
  {
    id: 1,
    category: "lifestyle",
    title: "Ayurvedic Daily Rituals for Long Vitality",
    excerpt: "Dinacharya routines to improve digestion, sleep, glow, immunity & emotional clarity.",
    image: DailyRitualImg,
    author: "Dr. Kiran Suryavanshi",
    date: "Dec 10, 2024",
    content: "Dinacharya, the Ayurvedic daily routine, is a sequence of habits that align our biological clocks with nature's rhythm. Starting the day with tongue scraping, oil pulling, and warm lemon water cleanses the system. Following this with Abhyanga (self-massage) and meditation prepares the mind and body for the day's challenges. These ancient practices are designed to maintain balance, reduce stress, and ensure long-term vitality.",
    isFeatured: true
  },
  {
    id: 2,
    category: "wellness",
    title: "Podcast: Seeds of Wellness",
    excerpt: "Healing conversations with practitioners about emotional resilience & balanced living.",
    image: wellnessImg,
    author: "Maya Desai",
    date: "Dec 8, 2024",
    content: "In our latest podcast episode, we dive deep into the concept of emotional resilience from an Ayurvedic perspective. Our guest practitioners share practical tips for managing stress, cultivating mindfulness, and creating a living environment that supports balanced mental health. We explore how tiny shifts in our daily habits can lead to profound changes in our overall well-being and life satisfaction.",
    isFeatured: true
  },
  {
    id: 3,
    category: "wellness",
    title: "What is Panchakarma Actually Healing?",
    excerpt: "Deep explanation of Vamanam, Virechanam, Basti & Nasya procedures & benefits.",
    image: panchakaramaImg,
    author: "Dr. Manisha Suryavanshi",
    date: "Dec 6, 2024",
    content: "Panchakarma is more than just a spa treatment; it is a profound physiological detox and rejuvenation program. It involves five primary actions: Vamana (emesis), Virechana (purgation), Basti (enema), Nasya (nasal therapy), and Raktamokshana (bloodletting). Each process specifically targets certain toxins and imbalances in the body. Understanding these procedures helps in appreciating how Ayurveda restores health by addressing the root cause of illness.",
    isFeatured: true
  },
  {
    id: 4,
    category: "yoga",
    title: "Yoga for Nervous System Reset",
    excerpt: "Breathwork routines for reducing cortisol spikes, anxiety & improving sleep.",
    image: yogaclassImg,
    author: "Yogi Arjun Patel",
    date: "Dec 4, 2024",
    content: "In our fast-paced modern world, our nervous systems are often stuck in high alert. This article explores specific yoga poses and Pranayama (breathing) routines designed to activate the parasympathetic nervous system. By focusing on slow, mindful movements and deep belly breathing, we can lower cortisol levels, quieten the mind, and significantly improve the quality of our sleep and recovery.",
    isFeatured: true
  },
  {
    id: 5,
    category: "herbs",
    title: "Gut Healing Herbs & Seasonal Diet",
    excerpt: "Understanding CCF tea, Triphala, buttermilk blends, and fermented grains.",
    image: "https://img.freepik.com/free-photo/ayurvedic-medicine-ingredients_23-2149374180.jpg",
    author: "Dr. Rajesh Kumar",
    date: "Dec 2, 2024",
    content: "The gut is the cornerstone of health in Ayurveda. This guide covers essential herbs like Triphala and CCF tea (Cumin, Coriander, Fennel) that support digestion and detoxification. We also discuss the importance of seasonal eating and incorporating probiotics through buttermilk and fermented foods. Learn how to tailor your diet to support your Agni (digestive fire) throughout the changing seasons.",
    isFeatured: true
  },

  // --- Other Stories (Re-indexed from ID 6) ---
  {
    id: 6,
    category: "herbs",
    title: "The Power of Turmeric",
    excerpt: "Golden spice for immunity and healing",
    image: TurmericImg,
    author: "Dr. Priya Sharma",
    date: "Nov 28, 2024",
    content: "Turmeric has been used in Ayurveda for thousands of years as a powerful anti-inflammatory agent. It contains curcumin, which has potent biological properties. Ayurvedic doctors recommend turmeric for nearly everything from chronic pain to inflammation. Its benefits are vast, including improved heart health, prevention against Alzheimer's and cancer, and potent anti-inflammatory and antioxidant effects.",
  },
  {
    id: 7,
    category: "yoga",
    title: "Morning Yoga Rituals",
    excerpt: "Start your day with ancient practices",
    image: morningYogaImg,
    author: "Yogi Arjun Patel",
    date: "Nov 25, 2024",
    content: "The ancient practice of Surya Namaskar (Sun Salutation) energizes the body and prepares the mind for the day ahead. Integrating these rituals into your morning can significantly enhance your physical flexibility and mental clarity. Morning yoga helps in balancing the doshas and awakening the prana. A consistent practice can transform your overall well-being, providing a foundation of peace and stability.",
  },
  {
    id: 8,
    category: "wellness",
    title: "Ayurvedic Massage Therapy",
    excerpt: "Abhyanga for body and soul",
    image: massageTherapyImg,
    author: "Maya Desai",
    date: "Nov 22, 2024",
    content: "Abhyanga, the traditional Ayurvedic oil massage, is a cornerstone of preventive healthcare. It involves massaging the entire body with warm, herb-infused oils tailored to your specific dosha. This practice not only nourishes the skin and improves circulation but also calms the nervous system and promotes detoxification. Regular Abhyanga is said to increase longevity and provide a sense of deep grounding.",
  },
  {
    id: 9,
    category: "lifestyle",
    title: "Ayurvedic Daily Routine",
    excerpt: "Dinacharya for balanced living",
    image: "https://assets.clevelandclinic.org/transform/LargeFeatureImage/2d536049-b17c-4b88-b1e3-85f78f7d9fea/Ayurveda-173877738-770x533-1_jpg",
    author: "Sanjana Reddy",
    date: "Nov 20, 2024",
    content: "Dinacharya, the Ayurvedic daily routine, synchronizes your body with natural circadian rhythms. This practice includes waking up early, tongue scraping, oil pulling, and meditation. By following a structured routine, you can maintain balance and prevent illness. Dinacharya helps in grounding the Vata dosha and ensuring that Agni (digestive fire) is functioning optimally throughout the day.",
  },
  {
    id: 10,
    category: "herbs",
    title: "Ashwagandha Benefits",
    excerpt: "Ancient adaptogen for modern stress",
    image: "https://assets.clevelandclinic.org/transform/8fe65f4e-04aa-4f24-81eb-d01daf7b6b77/Ashwagandha-winter-cherry-1703497855",
    author: "Dr. Rajesh Kumar",
    date: "Nov 18, 2024",
    content: 'Ashwagandha, known as the "strength of the stallion," is one of the most revered herbs in Ayurveda. It is an adaptogen, meaning it helps the body manage stress. Its benefits include reducing anxiety, improving sleep quality, and boosting cognitive function. Ashwagandha also supports muscle strength and recovery, making it a versatile herb for modern challenges.',
  },
  {
    id: 11,
    category: "wellness",
    title: "Herbal Tea Rituals",
    excerpt: "Healing brews from nature",
    image: "https://tastythriftytimely.com/wp-content/uploads/2021/09/Turmeric-Latte-4.jpg",
    author: "Kavita Joshi",
    date: "Nov 15, 2024",
    content: "Ayurvedic herbal teas are carefully crafted blends designed to balance the doshas. Whether it's ginger for digestion, tulsi for stress relief, or cumin-coriander-fennel (CCF) tea for detoxification, each blend has specific healing properties. The ritual of preparing and sipping these teas encourages mindfulness and provides a gentle way to support your body's natural healing processes.",
  },
  {
    id: 12,
    category: "yoga",
    title: "Pranayama Breathing",
    excerpt: "Master the life force through breath",
    image: "https://plus.unsplash.com/premium_photo-1661476140414-616180169219?q=60",
    author: "Guru Vikram Singh",
    date: "Nov 12, 2024",
    content: "Pranayama, the science of breath control, is a fundamental pillar of yoga. By manipulating the breath, you can influence the flow of prana (life force) in your body. Techniques like Nadi Shodhana (Alternate Nostril Breathing) and Kapalabhati help in clearing the energy channels and calming the mind. Regular practice of Pranayama improves lung capacity, reduces stress, and enhances mental clarity.",
  },
  {
    id: 13,
    category: "lifestyle",
    title: "Sattvic Food Philosophy",
    excerpt: "Eating for clarity and purity",
    image: SattvicFoodImg,
    author: "Chef Ananya Verma",
    date: "Nov 10, 2024",
    content: "Sattvic foods are pure, fresh, and naturally nourishing ingredients that promote clarity and purity. This diet emphasizes whole grains, fresh fruits and vegetables, nuts, seeds, and legumes. Avoiding processed foods, excessive spices, and caffeine allows the mind to reach a state of Sattva (equilibrium). Eating sattvic meals fosters physical health and mental peace, supporting a spiritual lifestyle.",
  },
  {
    id: 14,
    category: "herbs",
    title: "Holy Basil - Tulsi",
    excerpt: "The queen of herbs in Ayurveda",
    image: "https://i.pinimg.com/1200x/d8/b6/70/d8b670d33c4476f11c6f4dd41ec9d3b9.jpg",
    author: "Dr. Meera Iyer",
    date: "Nov 8, 2024",
    content: "Tulsi (Holy Basil) is revered as a sacred plant in Ayurveda, known for its extensive healing properties. It is a powerful adaptogen that helps the body cope with physical and mental stress. Tulsi is also known for its antibacterial, antiviral, and anti-inflammatory benefits. Drinking Tulsi tea or chewing fresh leaves can boost immunity, improve respiratory health, and provide a sense of spiritual upliftment.",
  },
  {
    id: 15,
    category: "wellness",
    title: "Ayurvedic Face Care",
    excerpt: "Natural beauty from within",
    image: "https://static.wixstatic.com/media/ed3c94_96a0f9c6d0a34e378952b6c79462fe6b~mv2.jpg",
    author: "Lakshmi Nair",
    date: "Nov 5, 2024",
    content: "Ayurvedic skincare focuses on natural ingredients and holistic approaches to beauty. Using Ubtans (herbal pastes), rose water, and natural oils like Kumkumadi oil can rejuvenate the skin without harsh chemicals. This practice emphasizes that external beauty is a reflection of internal health. Holistic skin care includes proper hydration, a balanced diet, and managing stress for a natural, healthy glow.",
  },
  {
    id: 16,
    category: "yoga",
    title: "Meditation for Inner Peace",
    excerpt: "Dhyana practice for mindfulness",
    image: "https://i.pinimg.com/736x/64/14/26/641426ef75aa9f3b03d3218774329eeb.jpg",
    author: "Swami Anand",
    date: "Nov 2, 2024",
    content: "Meditation or Dhyana is the practice of focusing the mind to achieve a state of clarity and calm. In Ayurveda, meditation is essential for balancing the mind and emotions. It helps in reducing the mental 'noise' and connecting with your true self. Whether it's mantra meditation or breath awareness, regular Dhyana practice reduces stress, improves concentration, and fosters a sense of profound inner peace.",
  },
  {
    id: 17,
    category: "lifestyle",
    title: "Ayurvedic Sleep Practices",
    excerpt: "Restore with quality rest",
    image: "https://i.pinimg.com/736x/a1/98/23/a19823f5f4952ddeb6df9f1cbf8b275d.jpg",
    author: "Dr. Arun Menon",
    date: "Oct 30, 2024",
    content: "Quality sleep is essential in Ayurveda for maintaining health and vitality. This practice involves sleeping and waking at regular times, avoiding heavy meals before bed, and creating a calm sleeping environment. Ayurvedic herbs like Brahmi and Ashwagandha can also support deep, restful sleep. Proper rest allows the body to repair itself and ensures that you wake up feeling refreshed and energized.",
  },
];
